import React from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';
import { Button } from './UIComponents';

interface TranscriptScrollFabProps {
  isAtBottom: boolean;
  isScrollable: boolean;
  onScrollToTop: () => void;
  onScrollToBottom: () => void;
  className?: string;
}

export const TranscriptScrollFab: React.FC<TranscriptScrollFabProps> = ({
  isAtBottom,
  isScrollable,
  onScrollToTop,
  onScrollToBottom,
  className = '',
}) => {
  console.log('[FAB]', { isScrollable, isAtBottom });
  if (!isScrollable) return null;

  const label = isAtBottom ? 'Scroll to top' : 'Scroll to bottom';
  const Icon = isAtBottom ? ChevronUp : ChevronDown;
  const handleClick = isAtBottom ? onScrollToTop : onScrollToBottom;

  return (
    <Button
      variant="secondary"
      size="icon"
      className={`absolute bottom-3 right-3 z-10 rounded-full shadow-lg bg-white/90 dark:bg-zinc-800/90 backdrop-blur border border-slate-200 dark:border-zinc-700 hover:shadow-xl transition-shadow ${className}`}
      onClick={handleClick}
      aria-label={label}
      title={label}
    >
      <Icon className="h-4 w-4" />
    </Button>
  );
};
